(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recensioni-carousel"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('reviews-carousel')) return;
  class ReviewsCarousel extends HTMLElement {
    connectedCallback() {
      if (this._controller) this._controller.abort();
      this._controller = new AbortController();
      const signal = this._controller.signal;
      this.track = this.querySelector('[data-rs-track]');
      this.prev = this.querySelector('[data-rs-prev]');
      this.next = this.querySelector('[data-rs-next]');
      if (!this.track) return;
      if (this.prev) this.prev.addEventListener('click', () => this.move(-1), { signal });
      if (this.next) this.next.addEventListener('click', () => this.move(1), { signal });
      this.track.addEventListener('scroll', () => this.updateButtons(), { passive: true, signal });
      window.addEventListener('resize', () => this.updateButtons(), { passive: true, signal });
      document.addEventListener('shopify:block:select', (event) => {
        const card = event.target.closest('[data-rs-card]');
        if (!card || !this.contains(card)) return;
        const left = card.getBoundingClientRect().left - this.track.getBoundingClientRect().left + this.track.scrollLeft;
        this.track.scrollTo({ left, behavior: 'smooth' });
      }, { signal });
      requestAnimationFrame(() => this.updateButtons());
    }
    disconnectedCallback() { this._controller?.abort(); this._controller = null; }
    move(dir) {
      const card = this.track.querySelector('[data-rs-card]');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const distance = card.getBoundingClientRect().width + gap;
      this.track.scrollBy({ left: dir * distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    updateButtons() {
      if (!this.track) return;
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      if (this.prev) this.prev.disabled = this.track.scrollLeft <= 3;
      if (this.next) this.next.disabled = this.track.scrollLeft >= max - 3;
    }
  }
  customElements.define('reviews-carousel', ReviewsCarousel);
})();

  } catch(e) { console.error(e); }
})();
})();
